// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"cacad244","156":"02030bd8","310":"df855f71","506":"a7a69c7e","634":"d4a497fb","806":"d9e524d7"}[chunkId] + ".chunk.js";
};